/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AllMediaFilterDTO } from './allMediaFilterDTO';


export interface AllMediaRequestDTO { 
    /**
     * Unique identifier of the client organization
     */
    clientId: number;
    /**
     * Unique identifier of the brand within the client
     */
    brandId: number;
    /**
     * Array of metric literal IDs to include as columns in the table, e.g. [\'salesI\', \'roasI\']. Get available IDs from the /metrics endpoint
     */
    metrics: Array<string>;
    /**
     * The level of detail for the table rows: \'tactic\' for tactic-level breakdown, \'campaign\' for campaign-level breakdown
     */
    dimension: AllMediaRequestDTO.DimensionEnum;
    filter: AllMediaFilterDTO;
}
export namespace AllMediaRequestDTO {
    export type DimensionEnum = 'tactic' | 'campaign';
    export const DimensionEnum = {
        Tactic: 'tactic' as DimensionEnum,
        Campaign: 'campaign' as DimensionEnum
    };
}


